import { Request } from '~src/httpClient/serverApi/requests/Request';
import {IResult} from '~src/httpClient/serverApi/types/IResponse';


export interface IGetSiteEncryptionKeyPolicyParams {
  externalKeyId: string;
}

export interface GetSiteEncryptionKeyPolicyResult extends IResult {
  policy: string;
}

export class GetSiteEncryptionKeyPolicyRequest extends Request<IGetSiteEncryptionKeyPolicyParams, GetSiteEncryptionKeyPolicyResult> {
  constructor(params: IGetSiteEncryptionKeyPolicyParams) {
    super('getSiteExternalEncryptionKeyPolicy', params);
  }
}